import React from "react";

import GetIcon from "Components/Global/Icons";

import * as S from "./styles";

import { useTheme } from "styled-components";

const ContainerWithTitle = ({
  icon,
  title,
  mt,
  children,
  fullscreen,
  ...rest
}) => {
  const theme = useTheme();

  const requestFullscreen = () => {
    const fullscreenArea = document.getElementById("fullscreen_area");
    fullscreenArea && fullscreenArea.requestFullscreen();
  };

  return (
    <S.Wrapper id="fullscreen_area" {...rest} mt={mt}>
      <S.Header>
        {icon && (
          <S.Icon>
            <GetIcon name={icon} color={theme.colors.primary.vividBlue} />
          </S.Icon>
        )}
        {title && <S.Title>{title}</S.Title>}
        {fullscreen && (
          <S.FullscreenButton
            onClick={() => {
              requestFullscreen();
            }}
          >
            {/* {getIcon("openFullscreen")} */}
          </S.FullscreenButton>
        )}
      </S.Header>

      <S.Content>{children}</S.Content>
    </S.Wrapper>
  );
};

export default ContainerWithTitle;
